import {
  EmailDeliveriesFilters,
  EmailDeliveriesResponse,
  EmailDeliveryEvent,
} from "@ac-expo/api-types";
import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import emailDeliveriesQueryKeys from "../query-keys/email-deliveries.query-keys";

const getEmailDeliveries = async (filters: EmailDeliveriesFilters) => {
  const { data } = await privateAxios.get<EmailDeliveriesResponse>("/email-deliveries", {
    params: filters,
  });
  return data;
};

export const useGetEmailDeliveriesQuery = (filters: EmailDeliveriesFilters) => {
  return useQuery({
    queryKey: emailDeliveriesQueryKeys.list(filters),
    queryFn: () => getEmailDeliveries(filters),
  });
};

const getEmailDeliveryEvents = async (emailDeliveryId: string) => {
  const { data } = await privateAxios.get<EmailDeliveryEvent[]>(
    `/email-deliveries/${emailDeliveryId}/events`,
  );
  return data;
};

export const useGetEmailDeliveryEventsQuery = (emailDeliveryId: string) => {
  return useQuery({
    queryKey: emailDeliveriesQueryKeys.events(emailDeliveryId),
    queryFn: () => getEmailDeliveryEvents(emailDeliveryId),
  });
};
